import './App.css';
import HomePage from 'pages/homepage/homepage';

function App() {
  return (
    <>
    <HomePage />
    <HomePage />
    </>
  );
}

export default App;
